import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Typography, Button } from '@quikr/ui';
import { returnUsableUser } from '../helpers/common';

const Wrapper = styled.div`
  line-height: 22px;
  @media screen and (min-width: 768px) {
    margin: -6px;
  }
`;

const Radio = styled.span`
  margin: 0 10px 0 9px;
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.TextGamma};
    position: absolute;
    top: 3px;
    left: 3px;
    display: none;
  }
  ${({ active }) =>
    active &&
    css`
      border-color: ${props => props.theme.colors.Primary};
      &:before {
        display: block;
        background: ${props => props.theme.colors.Primary};
      }
    `}
`;

const PacksWrapper = styled.div``;

const PacksTupple = styled.div`
  width: 215px;
  height: 61px;
  border: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  margin-bottom: 21px;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    width: 100%;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  ${({ active }) =>
    active &&
    css`
      border-color: ${props => props.theme.colors.Primary};
    `}
`;

const PacksData = styled.div`
  line-height: 18px;
  margin-right: auto;
`;

const Details = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextDelta};
`;

const ButtonWrap = styled.div`
  padding: 5px 0px 15px;
  @media screen and (max-width: 767px) {
    padding: 17px 0 0;
  }
`;

const Price = styled(Typography)`
  margin-right: 12px;
`;

const preparePayload = (user, { id }) => ({
  user: returnUsableUser(user),
  pack: {
    type: 'CONTACT_UNLOCK',
    id: id
  },
  landingPage: window.location.href
});

const PaymentPack = ({
  isMobile,
  recruiter: { contact_unlock_packs: packs = [] } = {},
  user,
  getLinkRequest
}) => {
  const [activePack, setActivePack] = useState(1);
  const [state, setState] = useState({ loading: false, err: false });

  const handleSubmit = async e => {
    setState({
      ...state,
      loading: true
    });
    const payLoad = preparePayload(user, packs[activePack]);
    const response = await getLinkRequest({
      variables: { payLoad }
    });
    const data = response.data;
    if (data.getPaymentLink && data.getPaymentLink.paymentUrl) {
      window.location.href = data.getPaymentLink.paymentUrl;
    } else {
      setState({
        loading: false,
        err: 'Something went wrong! Please try again later'
      });
    }
  };

  return (
    <Wrapper>
      <Typography className="form__heading" tagName="p">
        To continue viewing contact details of recruiters, select a plan
      </Typography>
      {state.err && (
        <Typography className="form__error" tagName="p">
          {state.err}
        </Typography>
      )}
      <PacksWrapper className="dF jcSB fwW">
        {packs &&
          packs.map((each, index) => (
            <PacksTupple
              className="dFA jcSB"
              isMobile={isMobile}
              onClick={() => setActivePack(index)}
              isLast={index === packs.length - 1}
              key={index}
              active={activePack === index}
            >
              <Radio className="pR cP radio" active={activePack === index} />
              <PacksData>
                <Details tagName="p" modifiers={['bold', 'bt1']}>
                  {each.credits} Contacts
                </Details>
                <Details tagName="p">{each.duration} Days</Details>
              </PacksData>
              <Price tagName="span" modifiers={['medium', 'h3']}>
                <span>₹</span>
                {each.price}
              </Price>
            </PacksTupple>
          ))}
      </PacksWrapper>
      {packs[activePack] && (
        <ButtonWrap className="taC">
          <Button
            className="form__button"
            onClick={handleSubmit}
            btnType="primary"
            size="lg"
            type="button"
            disabled={activePack < 0}
            loading={state.loading}
          >
            BUY FOR ₹{packs[activePack].price}
          </Button>
        </ButtonWrap>
      )}
    </Wrapper>
  );
};

PaymentPack.propTypes = {
  isMobile: PropTypes.bool,
  recruiter: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  getLinkRequest: PropTypes.func
};

PaymentPack.defaultProps = {
  isMobile: false
};

export default PaymentPack;
